import DASHBOARD_ACTIVE from '../../Assets/Images/dashboard_white.png';
import DASHBOARD from '../../Assets/Images/dashboard_black.png';
import USER_ACTIVE from '../../Assets/Images/user_white.png';
import USER from '../../Assets/Images/user_black.png';
import REPORT_ACTIVE from '../../Assets/Images/report_white.png';
import REPORT from '../../Assets/Images/report_black.png';
import CONTENT_ACTIVE from '../../Assets/Images/content_white.png';
import CONTENT from '../../Assets/Images/Content_black.png';
import NOTIFICATION_ACTIVE from '../../Assets/Images/notification_white.png'
import NOTIFICATION from '../../Assets/Images/Content_black.png'
import INCOMPLETE_ACTIVE from '../../Assets/Images/incompleteIcon_white.png'
import INCOMPLETE from '../../Assets/Images/incompleteIcon_black.png'
import SESSION_ACTIVE from '../../Assets/Images/session_white.png'
import SESSION from '../../Assets/Images/session_black.png'

export const NavMenuList = [
  {
    title: "Dashboard",
    path: '/admin/dashboard',
    icon: <img src={DASHBOARD} alt='dashboard' />,
    active: <img src={DASHBOARD_ACTIVE} alt='dashboard' />,
  },
  {
    title: "User Management",
    path: '/admin/user-management',
    icon: <img src={USER} alt='user' />,
    active: <img src={USER_ACTIVE} alt='useractive' />,
  },
  // {
  //   title: "Language Management",
  //   path: '/admin/language-management',
  //   icon: <GTranslateIcon />,
  //   active: <GTranslateIcon sx={{
  //     color:"#fff"
  //   }}/>,
  // },
  {
    title: "Content Management",
    path: '/admin/content-management',
    icon: <img src={CONTENT} alt='Content' />,
    active: <img src={CONTENT_ACTIVE} alt='Content' />,
  },
  {
    title: "Incomplete Services",
    path: '/admin/Incomplete-services',
    icon: <img src={INCOMPLETE} alt='INCOMPLETE' />,
    active: <img src={INCOMPLETE_ACTIVE} alt='REPORT' />,
  },
  {
    title: "Reported User",
    path: '/admin/reported-users',
    icon: <img src={REPORT} alt='REPORT' />,
    active: <img src={REPORT_ACTIVE} alt='REPORT' />,
  },
  {
    title: "Notifications",
    path: '/admin/notifications',
    icon: <img src={NOTIFICATION} alt='notifications' />,
    active: <img src={NOTIFICATION_ACTIVE} alt='notifications' />,
  },
  {
    title: "Session Management",
    path: '/admin/session-management',
    icon: <img src={SESSION} alt='notifications' style={{
      width: '22px',
      height: '22px',
    }}/>,
    active: <img src={SESSION_ACTIVE} alt='notifications' style={{
      width: '22px',
      height: '22px',
    }}/>,

  },
];